import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export type MemoryRule = z.infer<typeof MemoryRuleSchema>;

/**
 * Generic attempt at combining the Timely concepts of `ignore memory` and Tracker-based rules.
 */
export const MemoryRuleSchema = z.object({
  type: z
    .enum(['ignore', 'rewrite'])
    .default('ignore')
    .describe('Memory rule to `ignore` or `rewrite`'),
  matcher: z
    .enum(['equals', 'contains', 'startsWith', 'endsWith'])
    .default('equals')
    .describe('Memory rule matcher')
    .openapi({ example: 'contains' }),
  field: z
    .enum(['title', 'url', 'tool'])
    .default('title')
    .describe(
      'What rule should this apply to? The `tool` refers to the `app` on the Memory Recording API'
    ),
  rewrite_to: z
    .object({
      title: z.string().nullable().describe('What should the title be rewritten to?'),
      url: z.string().url().nullable().describe('What should the URL be rewritten to?'),
      tool: z
        .string()
        .nullable()
        .describe('What should the tool (aka `app` on the API) be rewritten to?'),
    })
    .or(z.null().openapi({ example: null }))
    .default(null),

  value: z
    .string()
    .default('')
    .describe('What value should this rule match?')
    .openapi({ example: 'string that is contained in `title`' }),
});

export type MemoryRuleDb = z.infer<typeof MemoryRuleDbSchema>;

export const MemoryRuleDbSchema = MemoryRuleSchema.extend({
  id: z.number().int().min(1),
});
